import { render, staticRenderFns } from "./AdGoals.vue?vue&type=template&id=9dace2c6&scoped=true&"
import script from "./AdGoals.vue?vue&type=script&lang=js&"
export * from "./AdGoals.vue?vue&type=script&lang=js&"
import style0 from "./AdGoals.vue?vue&type=style&index=0&id=9dace2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dace2c6",
  null
  
)

export default component.exports